import { AiAgentWbsItemRef } from '../../../lib/functions/ai'
import { AiAgentImageAttachmentState } from './hooks/useAiAgentImageUpload'

/**
 * 入力欄の内容（テキストと添付）。送信待ち行列に積む単位でもあり、
 * 編集時に入力欄と行列の間を行き来する。
 */
export type AiAgentChatDraft = {
  text: string
  images: AiAgentImageAttachmentState[]
  wbsItems: AiAgentWbsItemRef[]
}

export type AiAgentQueuedMessage = AiAgentChatDraft & {
  id: string
}

// 結合して1ターンで送るときの区切り。各メッセージは独立した依頼なので段落として分ける。
const MESSAGE_SEPARATOR = '\n\n'

// 同じWBSアイテムを複数回渡しても文脈は増えないため、先に現れたものだけを残す。
const distinctByCode = (items: AiAgentWbsItemRef[]): AiAgentWbsItemRef[] => {
  const seenCodes = new Set<string>()
  return items.filter(item => {
    if (seenCodes.has(item.code)) {
      return false
    }
    seenCodes.add(item.code)
    return true
  })
}

/**
 * 複数の下書きを1回分の送信内容にまとめる。本文は空行で連結し、添付は全件をマージする。
 * 送信待ちをまとめて送るときと、送信待ちが残ったまま新しいメッセージを送るときに使う。
 */
export const mergeDrafts = (drafts: AiAgentChatDraft[]): AiAgentChatDraft => ({
  text: drafts.map(draft => draft.text).join(MESSAGE_SEPARATOR),
  images: drafts.flatMap(draft => draft.images),
  wbsItems: distinctByCode(drafts.flatMap(draft => draft.wbsItems)),
})
